import TransformMonthlyValues from './transform-monthly-values.js'

export default {
    toPercentages: function(array,baseMonths){
        var baseA;
        var baseB;
        return array.map((item) => {
          if(!baseA && item > 0){ baseA = item; return 1; }
          if(!baseB && item > 0){ baseB = item; return 1; }
  
          var daysInBaseA = TransformMonthlyValues.daysInMonth(baseMonths[0]);
          var daysInBaseB = TransformMonthlyValues.daysInMonth(baseMonths[1]);

          return item / 
              (((baseA * daysInBaseA) + (baseB * daysInBaseB)) / (daysInBaseA + daysInBaseB))
        })
      },
      toPercentagesArrays: function(array,baseMonths){
        var baseA;
        var baseB;
        return array.map((item) => {
          if(!baseA && item[1] > 0){ baseA = item[1]; return [item[0], 1]; }
          if(!baseB && item[1] > 0){ baseB = item[1]; return [item[0], 1]; }
  
          var daysInBaseA = TransformMonthlyValues.daysInMonth(baseMonths[0]);
          var daysInBaseB = TransformMonthlyValues.daysInMonth(baseMonths[1]);

          return [
                item[0],
                (item[1] / 
              (((baseA * daysInBaseA) + (baseB * daysInBaseB)) / (daysInBaseA + daysInBaseB)))
              ]
        })
      }
}